import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../models/api/view/claim-view/claim-row';
import { IndexReport } from '../../../../models/api/view/claim/documentation/index-system/index-report';
import { IndexSystemMapper } from '../../../../utilities/index-system-mapper';
import { downloadFile } from '../../../../functions/download-file';
import { BaseComponent } from '../../../base/base.component';
import { LinkLabelComponent } from '../../../core/labels/link-label.component';
import { LoadingPanelComponent } from '../../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

interface IndexReportDisplay extends IndexReport {
  date: Date | null;
  report: string;
  type: string;
  matchCountDisplay: string;
  matchReasonDisplay: string;
}

@Component({
  selector: 'app-index-system-report',
  imports: [
    ColumnComponent,
    TableComponent,
    LinkLabelComponent,
    LoadingPanelComponent,
  ],
  template: `
    <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'" [error]="error">
      <ng-template #loaded>
        <app-table
          [dataSource]="reportData"
          [pageSize]="5"
          recordLabel="Index Report"
        >
          <app-column name="date" label="Date" width="10%" format="d" />
          <app-column name="report" label="Report" width="15%" />
          <app-column name="type" label="Type" width="15%" />
          <app-column
            name="matchCountDisplay"
            label="Match Count"
            width="15%"
          />
          <app-column
            name="matchReasonDisplay"
            label="Match Reason"
            width="20%"
          />
          <app-column name="" label="Match File" width="20%">
            <ng-template #download let-data>
              @if (data.reportFilename) {
                <app-link-label
                  (click)="downloadMatchFile(data, $event)"
                >
                  {{ data.reportFilename }}
                </app-link-label>
              }
            </ng-template>
          </app-column>
        </app-table>
      </ng-template>
    </app-loading-panel>
  `,
  styles: [],
})
export class IndexSystemReportComponent
  extends BaseComponent
  implements OnInit
{
  claim: ClaimRow;
  reportData: IndexReportDisplay[] = [];

  loading = false;
  error: any = null;

  @HandleLoadingState()
  async ngOnInit(): Promise<void> {
    this.claim = this.view.currentClaim();
    await this.loadReports();
  }

  @HandleLoadingState()
  async loadReports(): Promise<void> {
    const rawData = await this.api.indexSystem.getReports({
      recordSource: this.claim.recordSource,
      recordId: this.claim.recordId,
    });

    this.reportData = rawData.map((row) => {
      const mapped = IndexSystemMapper.mapReportRow(row);
      return {
        ...row,
        date: row.reportDate ? new Date(row.reportDate) : null,
        report: mapped.reportType,
        type: mapped.submitType,
        matchCountDisplay: mapped.matchCount,
        matchReasonDisplay: mapped.matchReason,
      };
    });
  }

  @HandleLoadingState({ errorProperty: 'actionError' })
  async downloadMatchFile(data: IndexReportDisplay, event?: Event): Promise<void> {
    if (event) {
      event.stopImmediatePropagation();
    }
    const blob = await this.api.indexSystem.downloadReport(
      { recordSource: this.claim.recordSource, recordId: this.claim.recordId },
      data.reportId,
    );
    downloadFile(blob, data.reportFilename, blob.type);
  }
}
